<div class="input-group mb-3">
  <input class="form-control form-control-sm" [placeholder]="placeholder" ngbDatepicker #d1="ngbDatepicker"
    [(ngModel)]="model" (ngModelChange)="onDateSelection($event)" [disabled]="disabled"
    style="min-width: 0; flex: 1 1 auto;">
    <div class="input-group-append border">
      <button class="btn btn-outline-secondary btn-sm btn-cal" (click)="d1.toggle()" type="button">
        <i class="bi bi-calendar"></i>
      </button>
    </div>
    @if (resetOption) {
      <div class="input-group-text m-pointer" (click)="datechange.emit('');">
        <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
      </div>
    }
  </div>